import React, { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from './router/router';
import { logoutAllTabs } from './services/logout-channel';
import { I18nextProvider } from 'react-i18next';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useTranslation } from 'react-i18next';
import './i18n';

function App() {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    logoutAllTabs();
  }, []);

  useEffect(() => {
    document.title = t('meta.metaTitle');

    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', t('meta.metaDescription'));
    }
  }, [i18n.language, t]);

  return (
    <I18nextProvider i18n={i18n}>
      <LocalizationProvider
        dateAdapter={AdapterDayjs}
        adapterLocale={i18n.language}
      >
        <RouterProvider router={router} />
      </LocalizationProvider>
    </I18nextProvider>
  );
}

export default App;
